export default "__VITE_ASSET__SxoCUPh9__"